import styled from 'styled-components'

export const MapItem = styled.div`
  height: 250px;
  width: 250px;
  cursor: pointer;
`
